import { z } from "zod";

import { InformationRequestDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { Patient, patientSchema } from "@/src/models/patient";

export const informationRequestTypeDisplay: Record<InformationRequestDocumentType, string> = {
  [InformationRequestDocumentType.INFORMATION_REQUEST]: "Information Request",
};

export const informationRequestSchema = z.object({
  patient: patientSchema,
});

export type InformationRequest = Omit<z.infer<typeof informationRequestSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const informationRequestShape: InformationRequest = {
  id: "",
  patient: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
};
